var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vue-good-table", {
    attrs: {
      columns: _vm.columnsConfig,
      rows: _vm.cellSettings,
      "pagination-options": {
        enabled: true,
        nextLabel: _vm.$t("txtNext"),
        prevLabel: _vm.$t("txtPrev"),
        rowsPerPageLabel: _vm.$t("txtPagePer"),
        ofLabel: _vm.$t("txtOf"),
        pageLabel: _vm.$t("txtPage"),
        allLabel: _vm.$t("txtAll"),
        perPage: 10
      },
      "search-options": { enabled: true, placeholder: _vm.$t("txtSearch") }
    },
    on: {
      "on-row-dblclick": function($event) {
        return _vm.gotoOeeSetting($event.row)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "table-row",
        fn: function(props) {
          return [
            props.column.field === "actions"
              ? _c("span", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.gotoOeeSetting(props.row)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-right" })]
                  )
                ])
              : _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(props.formattedRow[props.column.field]) +
                      "\n        "
                  )
                ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }